import React from "react";

const CardSalasColectivas = ({ sala, stado, salida }) => {

    stado === 'DISPONIBLE' ? salida = ' --- ' : salida = new Date(salida);

    const disponible = stado === 'DISPONIBLE';

    return (
        <tr>
            <td><b>{sala}</b></td>
            <td>
                <span className={disponible ? 'esen-chip esen-chip--success' : 'esen-chip esen-chip--danger'}>
                    <i className={disponible ? 'fa fa-check-circle' : 'fa fa-clock-o'} aria-hidden="true"></i>
                    {stado}
                </span>
            </td>
            <td>{disponible ? '---' : salida.toLocaleString()}</td>
        </tr>
        // <tr><td><b>{sala}</b> </td><td><small className="text-danger"><b>Fuera de uso temporalmente por medidas de bioseguridad</b></small></td><td> --- </td></tr>
    )


};

export default CardSalasColectivas;
